<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="#4E5F7E"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.7812 6.84375L13.1875 6.21875C13.0312 6.0625 12.7812 6.0625 12.6562 6.21875L7.8125 11.0625V0.375C7.8125 0.1875 7.625 0 7.4375 0H6.5625C6.34375 0 6.1875 0.1875 6.1875 0.375V11.0625L1.3125 6.21875C1.1875 6.0625 0.9375 6.0625 0.78125 6.21875L0.1875 6.84375C0.03125 6.96875 0.03125 7.21875 0.1875 7.375L6.71875 13.9062C6.875 14.0625 7.09375 14.0625 7.25 13.9062L13.7812 7.375C13.9375 7.21875 13.9375 6.96875 13.7812 6.84375Z" />
  </svg>
</template>
